import { render } from "./PreguntasFrecuentes.vue?vue&type=template&id=4a2d81ee&scoped=true&ts=true"
import script from "./PreguntasFrecuentes.ts?vue&type=script&lang=ts&external"
export * from "./PreguntasFrecuentes.ts?vue&type=script&lang=ts&external"

import "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=4a2d81ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2d81ee"]])

export default __exports__